import { Action } from "../actions/actionsShared";
import { FETCH_USER_ALERTS_PREFIX, FETCH_USER_ALERTS_SETTINGS_PREFIX } from "../actions/alertActions";


const initialState = {
  alerts: [],
  alertSettings: {},
  loadingAlerts: false
};

const alertReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${FETCH_USER_ALERTS_PREFIX}${Action.BEGIN_SUFFIX}`:
      return {
        ...state,
        loadingAlerts: true,
        result: 'BEGINNING',
      };
    case `${FETCH_USER_ALERTS_PREFIX}${Action.SUCCESS_SUFFIX}`:
      return {
        ...state,
        alerts: action.payload.data.data.message,
        loadingAlerts: false,
        result: 'SUCCESS',
      };
    case `${FETCH_USER_ALERTS_PREFIX}${Action.FAILURE_SUFFIX}`:
      return {
        ...state,
        loadingAlerts: false,
        result: 'FAILURE'
      }
    case `${FETCH_USER_ALERTS_SETTINGS_PREFIX}${Action.BEGIN_SUFFIX}`:
      return {
        ...state,
        result: 'BEGINNING',
      };
    case `${FETCH_USER_ALERTS_SETTINGS_PREFIX}${Action.SUCCESS_SUFFIX}`:
      return {
        ...state,
        alertSettings: action.payload.data.data.message,
        result: 'SUCCESS',
      };
    case `${FETCH_USER_ALERTS_SETTINGS_PREFIX}${Action.FAILURE_SUFFIX}`:
      return {
        ...state,
        result: 'FAILURE'
      }
    default:
      return state;
  }
};

export default alertReducer;
